export default __webpack_public_path__ + "static/makar-sankranti-7af4125e42f7ef61a6b3c6fd8b89efa6.png";